import { Component, Inject, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { AjastettuTyo, AjastettuTyoService } from '@lemon/core-firebase/eraajot/ajastettu/ajastetut-tyot.service'
import { DebugService } from 'app/_angular/service/debug.service'

@Component({
  templateUrl: './ajastetut-tyot-data.dialog.html',
  styleUrls: ['./ajastetut-tyot-data.dialog.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AjastetutTyotDataDialog {
  link: string

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AjastettuTyo<any>,
    private _debugService: DebugService,
    private _ajastettuTyoService: AjastettuTyoService,
  ) {
    this.link = this._debugService.createFirestoreLink(this._ajastettuTyoService.collectionName + '/' + data.avain)
  }
}
